export enum ParticipantSectionDataHooks {
  ROOT = 'participant-section',
  LIST_TITLE = 'participant-section-list-title',
  LEADING_DIVIDER = 'participant-section-leading-divider',
  HEADER = 'participant-section-header',
  TITLE = 'participant-section-title',
  TOGGLE = 'participant-section-toggle',
  REMOVE = 'participant-section-remove',
  CHEVRON = 'participant-section-chevron',
  BODY = 'participant-section-body',
}
